import { getLandingAccessToken } from '@/api/landings-http';
import { $features } from '@/entities/features-entity';
import { formatApiError } from '@/lib/format-api-error';
import { isDevMode } from '@/lib/is-dev-mode';
import axios from 'axios';
import { useUnit } from 'effector-react';
import { useCallback, useEffect, useState } from 'react';

export function useLandingsAccess() {
	const features = useUnit($features);
	const enabled = features.landingsEnabled;
	const [accessible, setAccessible] = useState(false);
	const [loading, setLoading] = useState(enabled);
	const [error, setError] = useState<string | null>(null);

	const verifyAccess = useCallback(async () => {
		if (!enabled) {
			setAccessible(false);
			setLoading(false);
			setError(null);
			return;
		}

		setLoading(true);
		setError(null);
		try {
			await getLandingAccessToken();
			setAccessible(true);
		} catch (err) {
			if (isDevMode && axios.isAxiosError(err) && !err.response) {
				setAccessible(true);
				setError(null);
				return;
			}
			setAccessible(false);
			if (axios.isAxiosError(err)) {
				setError(formatApiError(err.response?.data) ?? 'Не удалось получить доступ к лендингам');
			} else {
				setError('Не удалось получить доступ к лендингам');
			}
		} finally {
			setLoading(false);
		}
	}, [enabled]);

	useEffect(() => {
		void verifyAccess();
	}, [verifyAccess]);

	return { enabled, accessible, loading, error, retry: verifyAccess };
}
